import React from "react";
import { Modal, Paper, Typography, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { useDeleteSection } from "../../../hooks/useSections/useDeleteSections";

export const DeleteSection = ({ token, open, close, section, refresh }) => {
    const { loading, handleDelete } = useDeleteSection(
      token,
      section,
      refresh,
      close
    );

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <Typography variant="h6" style={{ mb: 2, margin: "10px 0" }}>
          ¿Estás seguro de que deseas eliminar esta sección?
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            fontStyle: "italic",
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          Nota: Esta acción no se podrá deshacer.
        </Typography>

        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button variant="contained" onClick={close} color="error">
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            color="primary"
            style={{ marginLeft: "20px" }}
            onClick={handleDelete}
            loading={loading}
          >
            Confirmar
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};